import styled from "@emotion/styled";
import { Box } from "@mui/material";
import {
  canShowAssetTypes,
  canShowComparison,
  useChartControls,
} from "./ChartControlsContext";
import { AssetTypeControl } from "./controls/AssetTypeControl";
import { ComparisonControl } from "./controls/ComparisonControl";

const BarContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  width: "100%",
  alignItems: "center",
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
}));

const ComparisonSlot = styled("div")({
  marginLeft: "auto",
});

interface Props {
  allTypeColor?: string;
}

export const ChartControlsDesktopBar = ({ allTypeColor }: Props) => {
  const ctx = useChartControls();

  if (!canShowAssetTypes(ctx) && !canShowComparison(ctx)) {
    return null;
  }

  return (
    <BarContainer>
      <AssetTypeControl allTypeColor={allTypeColor} />
      <ComparisonSlot>
        <ComparisonControl />
      </ComparisonSlot>
    </BarContainer>
  );
};
